import $ from 'jquery';
import 'select2';
import jQueryBridget from 'jquery-bridget';
import Isotope from 'isotope-layout';

require('select2/src/scss/core.scss');

// make Isotope a jQuery plugin
jQueryBridget( 'isotope', Isotope, $ );

(function ($) {
    $(document).ready(function () {


        $('.js-example-basic-multiple').select2({
            placeholder: "Please select"
        });

        $('.js-example-basic-single').select2();

        // store filter per group
        const filters = {};

        const $container = $('.wpk_isotope_container');

        $container.isotope();

        // do stuff when checkbox change
        $('.options').on('change', function (event) {


            const $select = event.target;
            const $selectVal = $($select);

            const group = $selectVal.attr('value-group');

            // create array for filter group, if not there yet
            let filterGroup = filters[group];

            if (!filterGroup) {
                filterGroup = filters[group] = [];
            }

            console.log(event.target.selectedOptions);

            if (event.target.value !== '') {
                let collection = event.target.selectedOptions;
                if (filterGroup.length) {
                    clearGroup(filterGroup);
                }

                for (let i = 0; i < collection.length; i++) {
                    if (!filterGroup.includes(collection[i].value)) {
                        filterGroup.push(collection[i].value);
                    }
                }
            } else {
                // remove filter
                clearGroup(filterGroup);
            }

            const comboFilter = getComboFilter();
            $container.isotope({filter: comboFilter});

            if (!$container.data('isotope').filteredItems.length) {
                console.log('empty');
                $('#msg-box').show();
            } else {
                $('#msg-box').hide();
            }
            //$filterDisplay.text( comboFilter );

        });

        function clearGroup(filterGroup) {
            let filterCount = filterGroup.length;
            while (filterCount >= 0) {
                filterGroup.splice(filterCount, 1);
                filterCount--;
            }
        }

        function getComboFilter() {
            let combo = [];
            for (let prop in filters) {
                const group = filters[prop];
                if (!group.length) {
                    // no filters in group, carry on
                    continue;
                }
                // add first group
                if (!combo.length) {
                    combo = group.slice(0);
                    continue;
                }
                // add additional groups
                const nextCombo = [];
                // split group into combo: [ A, B ] & [ 1, 2 ] => [ A1, A2, B1, B2 ]
                for (let i = 0; i < combo.length; i++) {
                    for (let j = 0; j < group.length; j++) {
                        const item = combo[i] + group[j];
                        nextCombo.push(item);
                    }
                }
                combo = nextCombo;
            }
            const comboFilter = combo.join(', ');
            return comboFilter;
        }

    });
})(jQuery);
